module.exports = function () {

    let module = {};


    module.locations = function () {

        var locationCodes = ["p", "trn", "gcs", "nc", "rst", "lc", "sup", "cin", "h", "fpt", "sch"];
        var locationToIcon = {
            'trn': 'fa-train',
            'p': 'fa-glass',
            'nc': 'fa-group',
            'rst': 'fa-cutlery',
            'lc': 'fa-futbol-o',
            'sup': 'fa-shopping-basket',
            'cin': 'fa-video-camera',
            'h': 'fa-hospital-o',
            'sch': 'fa-child'
        };
        var locationMarkers = new Array();
        var infoWindows = new Array();
        var markers = new Array();


        let propertyLatitude = $('.property-details-map').data('latitude');
        let propertyLongitude = $('.property-details-map').data('longitude');
        let sfsURL = "https://sfs.hiveeas.com/";
        let sfsIconColour = "#932F2F";
        let countLocationsBetweenURL = sfsURL + "countLocationsBetween/?locationLatitude=" + propertyLatitude + "&locationLongitude=" + propertyLongitude;
        let getLocationsBetweenURL = sfsURL + "getLocationsBetween/?locationLatitude=" + propertyLatitude + "&locationLongitude=" + propertyLongitude;
        let locationChecked = new Array();

        $(".sfs-link").on("click", function (e) {
            e.preventDefault();
            if (jQuery(this).hasClass("active")) {
                index = locationChecked.indexOf(jQuery(this).val());
                locationChecked.splice(index, 1);
                removeLocationType(jQuery(this).attr("sfsID"));
                jQuery(this).removeClass("active");
            } else {
                locationChecked.push(jQuery(this).attr("sfsID"));
                addLocationType(map, jQuery(this).attr("sfsID"));
                jQuery(this).addClass("active");
            }
        });


        function addLocationType(map, locationCode) {
            getURL = getLocationsBetweenURL + getBoundParams(map)
                + "&locationTypeCodes=" + locationCode;
            jQuery.get(getURL, function (data) {
                if (data.errors) {

                } else {
                    var i = 0;
                    for (x in data.locations) {
                        for (y in data.locations[x]) {
                            addLocationMarker(x, data.locations[x][y], map, i);
                            i++;
                        }
                    }
                }
            });
            locationMarkers.push(locationCode);
        }

        function updateLocations(map) {
            countLocations(map);
            getURL = getLocationsBetweenURL + getBoundParams(map)
                + getActiveLocationCodesParam(map);
            // jQuery("#googleMap").addClass("loading");
            jQuery.get(getURL, function (data) {
                if (data.errors) {

                } else {
                    for (x in data.locations) {
                        for (y in data.locations[x]) {
                            //If location is not already visible add it
                            if (markers[x][data.locations[x][y].id] == undefined) {
                                addLocationMarker(x, data.locations[x][y], map);
                            }
                        }
                        //TODO If there are locations that no longer exist remove them
                    }
                }
                // jQuery("#googleMap").removeClass("loading");
            });
        }

        function countLocations(map) {
            countURL = countLocationsBetweenURL + getBoundParams(map);
            jQuery.get(countURL, function (data) {
                if (data.errors) {

                } else {
                    // Change to for each locCount class
                    for (x in locationCodes) {
                        code = locationCodes[x];
                        count = 0;
                        if (data.locationCount[code]) {
                            count = data.locationCount[code];
                        }
                        jQuery("#locCount" + code).html(count);
                    }
                }
            });
        }

        function removeLocationType(type) {

            for (x in markers[type]) {
                markers[type][x].setMap(null);
            }

            delete infoWindows[type];
            delete markers[type];
            locationMarkers.splice(locationMarkers.indexOf(type), 1);
        }

        function addLocationMarker(type, location, map) {
            if (markers[type] == undefined) {
                markers[type] = new Array();
                infoWindows[type] = new Array();
            }

            infoWindows[type][location.id] = new google.maps.InfoWindow({
                content: location.name
            });
            /*markers[type][location.id] = new google.maps.Marker({
               position: new google.maps.LatLng(location.latitude, location.longitude),
               map: map,
               icon: sfsURL + "/resources/images/sfs/" + type + ".png"
            });*/
            markers[type][location.id] = new MarkerWithLabel({
                position: new google.maps.LatLng(location.latitude, location.longitude),
                draggable: false,
                raiseOnDrag: false,
                icon: ' ',
                map: map,
                labelContent: '<i class="fa ' + locationToIcon[type] + ' fa-2x" style="color:' + sfsIconColour + ';"></i>',
                labelAnchor: new google.maps.Point(0, 0)
            });
            google.maps.event.addListener(markers[type][location.id], 'click', function () {
                infoWindows[type][location.id].open(map, markers[type][location.id]);
            });

        }

        function getActiveLocationCodesParam(map) {

            param = "&locationTypeCodes=";
            locations = "";

            for (x in locationChecked) {
                if (locations != "") {
                    locations += ",";
                }
                if (locationChecked[x]) {
                    locations += locationChecked[x];
                }
            }

            return param + locations;
        }

        function getBoundParams(map) {
            return "&lat1=" + map.getBounds().getNorthEast().lat() + "&lat2="
                + map.getBounds().getSouthWest().lat() + "&long1="
                + map.getBounds().getNorthEast().lng() + "&long2="
                + map.getBounds().getSouthWest().lng() + "&centerLat="
                + propertyLatitude + "&centerLong="
                + propertyLongitude;
        }

    }

    module.search = function () {
        if (('.search-bar').length) {
            var noMinOption = '<option value="">No Min</option>';
            var noMaxOption = '<option value="">No Max</option>';

            // Parse the JSON data
            var salesPriceBandOptions = $('.search-bar').data('sales-prices');
            var lettingsPriceBandOptions = $('.search-bar').data('lettings-prices');

            var urlMinPrice = getParameterByName('minPrice');
            var urlMaxPrice = getParameterByName('maxPrice');


            function getParameterByName(name, url) {
                if (!url) url = window.location.href;
                name = name.replace(/[\[\]]/g, "\\$&");
                var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return '';
                return decodeURIComponent(results[2].replace(/\+/g, " "));
            }


            $("#residentialPropertySearch").autocomplete({source: "https://api.hiveeas.com/area/209/match", minLength: 2});
            $("#commercialPropertySearch").autocomplete({source: "https://api.hiveeas.com/area/209/match", minLength: 2});
                // $("#schoolPropertySearch").autocomplete({
                //     source: "https://api.hiveeas.com/location/match/sch",
                //     minLength: 2
                // });
                //$("#stationPropertySearch").autocomplete({source : "/matchTrainStations/",minLength : 2});
                //$('#locationSaleType').val('/residential/residential-property-sales');
                //$('#stationSaleType').val('/residential/residential-property-sales');
                //$('#schoolSaleType').val('/residential/residential-property-sales');
                // $('#minPrice').empty().append(noMinOption + salesPriceBandOptions);
                // $('#maxPrice').empty().append(noMaxOption + salesPriceBandOptions);
                //$('#stationMinPrice').empty().append(noMinOption + salesPriceBandOptions);
                //$('#stationMaxPrice').empty().append(noMaxOption + salesPriceBandOptions);
                // $('#schoolMinPrice').empty().append(noMinOption + salesPriceBandOptions);
                // $('#schoolMaxPrice').empty().append(noMaxOption + salesPriceBandOptions);



                $('.location-sale-type').bind('change', function () {

                    console.log('Type change');

                    let id = $(this).attr('id');
                    let tab = (id == 'residentialSaleType') ? '#nav-residential' : '#nav-commercial';

                    let el = $(this).parents(tab);
                    let type = $.trim($(el).find("select[name='page_id']").find("option:selected").text());
                    let minPriceField = $(el).find("select[name='minPrice']");
                    let maxPriceField = $(el).find("select[name='maxPrice']");

                    minPriceField.empty().append(noMinOption);
                    maxPriceField.empty().append(noMaxOption);
                    console.log(type);

                    if (type == "Sales") {
                        $.each(salesPriceBandOptions, function (index, option) {
                            minPriceField.append($('<option>', {  value: index, text: option  }));
                            maxPriceField.append($('<option>', {  value: index, text: option }));
                        });

                    }else{
                        $.each(lettingsPriceBandOptions, function (index, option) {
                            minPriceField.append($('<option>', {  value: index, text: option  }));
                            maxPriceField.append($('<option>', {  value: index, text: option   }));
                        });
                    }

                    if (urlMinPrice)
                        minPriceField.val(urlMinPrice);

                    if (urlMinPrice)
                        maxPriceField.val(urlMaxPrice);
                });


                // run the above on load
                //$('.location-sale-type').trigger('change');


                /*$('#stationSaleType').bind('change', function() {
                        if($('#stationSaleType').val() == 1) {
                                $('#stationMinPrice').empty().append(noMinOption + salesPriceBandOptions);
                                $('#stationMaxPrice').empty().append(noMaxOption + salesPriceBandOptions);
                        } else {
                                $('#stationMinPrice').empty().append(noMinOption + lettingsPriceBandOptions);
                                $('#stationMaxPrice').empty().append(noMaxOption + lettingsPriceBandOptions);
                        }
                });*/
                // $('#schoolSaleType').bind('change', function () {
                //     if ($('#schoolSaleType').endsWith("sales")) {
                //
                //         $('#schoolMinPrice').empty().append(noMinOption);
                //         $('#schoolMaxPrice').empty().append(noMaxOption);
                //
                //         $.each(salesPriceBandOptions, function (index, option) {
                //             $('#schoolMinPrice').append($('<option>', {
                //                 value: index, text: option
                //             }));
                //         });
                //
                //         $.each(salesPriceBandOptions, function (index, option) {
                //             $('#schoolMaxPrice').append($('<option>', {
                //                 value: index, text: option
                //             }));
                //         });
                //
                //
                //     } else {
                //
                //         $('#schoolMinPrice').empty().append(noMinOption);
                //         $('#schoolMaxPrice').empty().append(noMaxOption);
                //
                //         $.each(lettingsPriceBandOptions, function (index, option) {
                //             $('#schoolMinPrice').append($('<option>', {
                //                 value: option.value, text: option.text
                //             }));
                //         });
                //
                //         $.each(lettingsPriceBandOptions, function (index, option) {
                //             $('#schoolMaxPrice').append($('<option>', {
                //                 value: option.value, text: option.text
                //             }));
                //         });
                //
                //     }
                //
                //     if (urlMinPrice)
                //         $('#schoolMinPrice').val(urlMinPrice);
                //
                //     if (urlMinPrice)
                //         $('#schoolMaxPrice').val(urlMaxPrice);
                //
                //
                // });

                // $("#locationSearchBtn").click(function(e) {
                //     e.preventDefault();
                //     window.location=createPropertySearchURL($("#locationSaleType").val(), "", "", $("#minPrice").val(), $("#maxPrice").val(), "", $("#propertySearch").val(),
                //         $("#polyLocationRadius").val(), "", true);
                // });
                // $("#schoolSearchBtn").click(function (e) {
                //     e.preventDefault();
                //     var url = "/school/";
                //     window.location = createPropertySearchURL($("#schoolSaleType").val(), "", "", $("#schoolMinPrice").val(), $("#schoolMaxPrice").val(), "", "",
                //         $("#polySchoolRadius").val(), $("#schoolPropertySearch").val(), true);
                // });
                /* $("#stationSearchBtn").click(function(e) {
                     e.preventDefault();
                     var url = "/station/";
                     var salesFlag = true;
                     if($("#stationSaleType").val() == "1") {
                             salesFlag = true;
                     } else {
                             salesFlag = false;
                     }
                     url += createPropertySearchURL("list", salesFlag, "", "", $("#stationMinPrice").val(), $("#stationMaxPrice").val(), "",
     $("#stationPropertySearch").val(), $("#polyStationRadius").val(), true);
                     window.location=url;
                 });*/


        }

    }

    module.stampDutyButton = function () {
        $('#calculate-stamp-btn').click(function () {
            module.stampDutyCalculate();
            $('.stamp-results').removeClass('d-none');
        });
    }

    module.stampDutyCalculate = function () {


        Number.prototype.money = function (c, d, t) {
            var n = this,
                c = isNaN(c = Math.abs(c)) ? 2 : c,
                d = d == undefined ? "." : d,
                t = t == undefined ? "," : t,
                s = n < 0 ? "-" : "",
                i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
                j = (j = i.length) > 3 ? j % 3 : 0;
            return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
        };

        if ($('#stamp-property-price').length) {
            $('#stamp-duty-amount').html(
                getprice($('#stamp-property-price').val())
            );
        } else
            $('#stamp-duty-amount').html(
                getprice($('#stamp-duty-amount').data('price'))
            );

        function getprice(x) {
            var r = 0;
            var p, q;
            x = parseInt(x);
            var ss = '';
            if (x <= 125000) {
                return 0;
            }
            q = x > 250000 ? 125000 : x - 125000;
            p = q * 0.02;
            r += p;
            if (x > 250000) {
                q = x >= 925000 ? (925000 - 250000) : x - 250000;
                p = q * 0.05;
                r += p;
            }
            if (x > 925000) {
                q = x >= 1500000 ? (1500000 - 925000) : x - 925000;
                p = q * 0.1;
                r += p;
            }
            if (x > 1500000) {
                q = x - 1500000;
                p = q * 0.12;
                r += p;
            }
            return r.money(2, '.', ',');
        }

        function getfirsttimebuyerprice(x) {
            var r = 0;
            var p, q;
            x = parseInt(x);
            var ss = '';
            if (x <= 300000) {
                return 0;
            }
            if (x <= 500000) {
                q = x - 300000;
                p = q * 0.05;
                r += p;
                return r.money(2, '.', ',');
            } else {
                return getprice(x);
            }
        }

        function getsecondhomeprice(x) {
            var r = 0;
            var p, q;
            x = parseInt(x);
            var ss = '';
            q = x >= 125000 ? 125000 : x;
            p = q * 0.03;
            r += p;
            if (x > 125000) {
                q = x >= 250000 ? 125000 : x - 125000;
                p = q * 0.05;
                r += p;
            }
            if (x > 250000) {
                q = x >= 925000 ? (925000 - 250000) : x - 250000;
                p = q * 0.08;
                r += p;
            }
            if (x > 925000) {
                q = x >= 1500000 ? (1500000 - 925000) : x - 925000;
                p = q * 0.13;
                r += p;
            }
            if (x > 1500000) {
                q = x - 1500000;
                p = q * 0.15;
                r += p;
            }
            return r.money(2, '.', ',');
        }

    }


    module.mortgageCalculate = function () {

        require('jquery-numeric');

        function numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }

        $("#annual_interest-rate").numeric();
        $("#deposit_amount").numeric();
        $("#reset-mortgage-btn").on("click", function (e) {
            e.preventDefault();
            $(".mortgage-calculator-input-area").show();
            $(".mortgage-calculator-results-area").hide();
        });
        $("#deposit_amount").change(function () {
            $("#loan-amount").val($("#mortgage-property-price").val() - $("#deposit_amount").val());
        });
        $("#calculate-mortgage-btn").on("click", function (e) {
            e.preventDefault();
            //Check its not empty and that it contains a valid number or decimal number
            if ($("#annual_interest-rate").val().trim() == "") {
                if (!$("#annual_interest-rate").hasClass("field-error")) {
                    $("#annual_interest-rate").addClass("field-error");
                }
                return;
            }
            var monthlyPayments = $("#mortgage-term").val() * 12;
            var depositAmount = $("#deposit_amount").val();
            var mortgageAmount = $("#mortgage-property-price").val() - depositAmount;
            var rate = $("#annual_interest-rate").val() / 100;
            var monthlyRate = rate / 12;
            var term = Math.pow((1 + (monthlyRate)), monthlyPayments);
            var monthlyPayment = mortgageAmount * ((monthlyRate * term) / (term - 1));
            monthlyPayment = Math.round(monthlyPayment * 100) / 100;

            $("#mortgage-calculator-amount-borrowed").html(numberWithCommas(mortgageAmount));
            $("#mortgage-calculator-no-repayments").html(monthlyPayments);
            $("#mortgage-calculator-payment-amount").html(numberWithCommas(monthlyPayment));

            //Remove any errors
            $("#annual_interest-rate").removeClass("field-error");
            $("#deposit_amount").removeClass("field-error");


            $(".mortgage-calculator-results-area").show();
        });
    };

    return module;

};
